import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Field } from 'react-final-form';
import { Grid } from '@material-ui/core';
import FormTextField from '../../form/FormTextField';
import FormZipCode from '../../form/FormZipCode';

const ParticipantAddress = ({ t, fieldPrefix }) => (
  <div>
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={8}>
        <Field
          name={`${fieldPrefix}.address.street`}
          component={FormTextField}
          label={t('auth.userProfile.form.address.street')}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={3} md={2}>
        <Field
          name={`${fieldPrefix}.address.streetNumber`}
          component={FormTextField}
          label={t('auth.userProfile.form.address.streetNumber')}
        />
      </Grid>
      <Grid item xs={12} sm={3} md={2}>
        <Field
          name={`${fieldPrefix}.address.apartmentNumber`}
          component={FormTextField}
          label={t('auth.userProfile.form.address.apartmentNumber')}
        />
      </Grid>
    </Grid>
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4} md={2}>
        <Field
          name={`${fieldPrefix}.address.zipCode`}
          component={FormZipCode}
          label={t('auth.userProfile.form.address.zipCode')}
        />
      </Grid>
      <Grid item xs={12} sm={8} md={10}>
        <Field
          name={`${fieldPrefix}.address.city`}
          component={FormTextField}
          label={t('auth.userProfile.form.address.city')}
          fullWidth
        />
      </Grid>
    </Grid>
  </div>
);

ParticipantAddress.propTypes = {
  fieldPrefix: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default translate()(ParticipantAddress);



// WEBPACK FOOTER //
// ./src/components/auth/registration/ParticipantAddress.js